import { ComponentProps } from "@declarations/props";

export const SemiCircle: ComponentProps = () => {
  return (
    <div
      className="bg-semi-circle tw-h-[400px]"
      style={{
        background: "linear-gradient(160deg, #0f5fa8 0%, #56b6fd 55%, #3b82f6 100%)",
      }}
    >
      <svg
        className="curve"
        viewBox="0 0 100 12"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: "-1px",
          left: "0",
          width: "100%",
          height: "110px",
        }}
      >
        <path d="M0,4 Q25,12 50,5 Q75,-2 100,4 L100,30 L0,30 Z" fill="#f7f7f8" />
      </svg>
    </div>
  );
};
